// extracted by mini-css-extract-plugin
export var productImage = "_ms-0";